module.exports = __webpack_public_path__ + "img/s8.717fa8e3.svg";